import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field} from 'redux-form';
import withStyles from '@mui/styles/withStyles';
import Modal from '@mui/material/Modal';
import Grid from '@mui/material/Grid';
// import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
// import SaveIcon from '@mui/icons-material/Save.js';
import withRouter from '../../../organisms/withRouter.js';
import PositiveButton from '../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
import {commonOperations} from '../../../../reducks/common/index.js';
import {renderRadioGroup} from '../../../atoms/CustomPart.js';
import PaperPart from '../../../atoms/PaperPart.js';
import {
  Typography,
  FormControlLabel,
  Radio,
} from '@mui/material';

const styles = (theme) => ({
  modal: {
    alignItems: 'center',
    justifyContent: 'center',
    overflowY: 'none',
  },
  paper: {
    backgroundColor: '#fafafa',
    border: '3px solid #fafafa',
    width: 'auto',
    minWidth: '25%',
    height: 'auto',
    idth: '95%',
    overflow: 'auto',
    padding: '16pt',
    fontSize: '10pt',
    position: 'absolute',
    top: '45%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  button: {
    margin: '15px 10px 5px 10px',
  },

});

class Questionnaire extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      commentBtnDisabled: true,
      tsTk: true,
      tyoSa: false,
      tenKen: false,
    };
  }

  closeModal = () => {
    console.log('close');
    this.props.doCloseModal();
  };

  setBtnDisable = (e, o) => {
    if (null === o || o.trim() === '') {
      this.setState({
        commentBtnDisabled: true,
      });
    } else {
      this.setState({
        commentBtnDisabled: false,
      });
    }
  };


  render() {
    const {classes, openState, handleClose, handleExec} = this.props;

    return (
      <Modal
        open={openState}
      >
        <PaperPart className={classes.paper}>
          <Typography variant='h6' sx={{fontWeight: 'bold'}}>点検結果一括設定</Typography>
          <div style={{marginBottom: '20px'}} />
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
          >
            <Grid key='tkResult' item xs={3} sm={10} direction='column-reverse'>
              <Field
                key='tkResult'
                id='tkResult'
                name='tkResult'
                label=""
                component={renderRadioGroup}
                onChange={this._handleChangeRadio}
                column
              >
                <FormControlLabel
                  key='tkResult1'
                  value='tkResult1'
                  control={<Radio />}
                  label={
                    <p style={{color: '#000', marginBottom: '15px'}}>
                  ①引込線良
                    </p>}
                />
                <FormControlLabel
                  key='tkResult2'
                  value='tkResult2'
                  control={<Radio />}
                  label={
                    <p style={{color: '#000', marginBottom: '15px'}}>
                  ②計器良
                    </p>}
                />
                <FormControlLabel
                  key='tkResult3'
                  value='tkResult3'
                  control={<Radio />}
                  label={
                    <p style={{color: '#000', marginBottom: '15px'}}>
                  ③引込線・計器良
                    </p>}
                />
                <FormControlLabel
                  key='tkResult4'
                  value='tkResult4'
                  control={<Radio />}
                  label={
                    <p style={{color: '#000', marginBottom: '15px'}}>
                  ④外灯(引込なし)
                    </p>}
                />
                <FormControlLabel
                  key='tkResult5'
                  value='tkResult5'
                  control={<Radio />}
                  label={
                    <p style={{color: '#000', marginBottom: '15px'}}>
                  ⑤地中引込
                    </p>}
                />
                <FormControlLabel
                  key='tkResult6'
                  value='tkResult6'
                  control={<Radio />}
                  label={
                    <p style={{color: '#000', marginBottom: '15px'}}>
                  ⑥高圧引込
                    </p>}
                />
              </Field>
            </Grid>
          </Grid>
          <div style={{marginBottom: '20px'}} />
          <Grid
            container
            justifyContent="center"
            alignItems="flex-end"
            spacing={1}
          >
            <Grid key="btnCreateComment" item >
              <PositiveButton
                id="btnCreateComment"
                variant="contained"
                // startIcon={<Cancel />}
                size="middium"
                // disabled={this.state.commentBtnDisabled}
                // onClick={handleExec}
                onClick={handleExec}
              >
                <span>OK</span>
              </PositiveButton>
            </Grid>
            <Grid key="keyModalCloseBtn" item >
              <NegativeButton
                id="btnCloser"
                variant="contained"
                // startIcon={<KeyboardReturnIcon />}
                size="middium"
                onClick={handleClose}
              >
                <span>キャンセル</span>
              </NegativeButton>
            </Grid>
          </Grid>
        </PaperPart>
      </Modal>
    );
  }
}

Questionnaire.propTypes = {
  classes: PropTypes.object,
  modalInfo: PropTypes.object,
  content: PropTypes.object,
  doCloseModal: PropTypes.func,
  handleClose: PropTypes.func,
  handleExec: PropTypes.func,
  openState: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  modalInfo: state.common.modalInfo,
});

const mapDispatchToProps = {
  doCloseModal: commonOperations.doCloseModal,
};

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Questionnaire)),
);
